import {
  afterNextRender,
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  input,
  Renderer2,
} from '@angular/core';

export type AosAnimation =
  | 'fade'
  | 'fade-up'
  | 'fade-down'
  | 'fade-left'
  | 'fade-right'
  | 'zoom-in';

@Directive({
  selector: '[aos]',
  host: {
    '[attr.data-aos]': 'aos()',
    '[style.--aos-delay]': 'aosDelay() + "ms"',
    '[style.--aos-duration]': 'aosDuration() + "ms"',
  },
})
export class AosDirective {
  readonly aos = input.required<AosAnimation>();
  readonly aosDelay = input(0);
  readonly aosDuration = input(900);
  readonly aosOnce = input(true);

  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    afterNextRender(() => {
      const element = this.el.nativeElement as HTMLElement;
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.renderer.addClass(element, 'aos-animate');
              if (this.aosOnce()) {
                observer.unobserve(element);
              }
            } else if (!this.aosOnce()) {
              this.renderer.removeClass(element, 'aos-animate');
            }
          }
        },
        { threshold: 0.15 }
      );

      observer.observe(element);

      this.destroyRef.onDestroy(() => observer.disconnect());
    });
  }
}
